export default __webpack_public_path__ + "static/media/@yasrodrigues._.479caafc.jpg";